'use client';

import React, { createContext, useContext, useEffect } from 'react';
import { useBondsAssetClassesContext } from '@/creditflowresearch/application/Bonds/BondsAssetClassesContext';
import { useBwicTableContext, IBwicsData } from './BwicTableContext';
import { useInventoryTableContext, IInventoryData } from './InventoryTableContext';
import { useUserPlanContext } from '@/creditflowresearch/application/User/UserPlan/UserPlanContext';
import { useBondsFiltersContext } from '@/creditflowresearch/application/Bonds/BondsFiltersContext';

interface IBondsData {
  bwicsData: IBwicsData,
  inventoriesData: IInventoryData,
}

const useBonds = (): IBondsData => {
  const { currentAssetClass } = useBondsAssetClassesContext();
  const { bwicsData } = useBwicTableContext();
  const { inventoriesData } = useInventoryTableContext();
  const { isPro } = useUserPlanContext();
  const { initBonds } = useBondsFiltersContext();

  useEffect(() => {
    if (currentAssetClass && isPro) initBonds();
  }, [currentAssetClass, isPro]);

  return {
    bwicsData,
    inventoriesData,
  };
};

const BondsContext = createContext(null);

export const useBondsContext = () => {
  const context = useContext(BondsContext);
  if (!context) {
    throw new Error('useBondsContext must be used within the BondsContext');
  }
  return context;
};

interface IProps {
  children: React.ReactNode,
}

const BondsContextProvider = ({ children }: IProps) => (
  <BondsContext.Provider value={ useBonds() }>
    { children }
  </BondsContext.Provider>
);

export default BondsContextProvider;
